import type { StatementBlockKey } from '../types/dealerFundStatementPeriod.types';

export type PostingsLayout = 'split' | 'net' | 'net_with_invoice';

const LAYOUTS: Record<StatementBlockKey, PostingsLayout> = {
    motorplan_handled: 'split',
    dealer_handled: 'split',
    internal: 'net',
    paid_out: 'net_with_invoice',
};

export const postingsLayoutFor = (key: StatementBlockKey): PostingsLayout => LAYOUTS[key];

/** Statement grid figure widths plus its 24px gap, so each table figure ends where the grid's figure does. */
export type PostingsFigureColumnId = 'vatRate' | 'gross' | 'vat' | 'net';

export const POSTINGS_FIGURE_COLUMN_PX: Record<PostingsFigureColumnId, number> = { vatRate: 120, gross: 152, vat: 136, net: 152 };

export const POSTINGS_TEXT_COLUMN_PX = 160;

const TEXT_COLUMN_COUNT: Record<PostingsLayout, number> = { split: 6, net_with_invoice: 7, net: 6 };
const FIGURE_COLUMNS: Record<PostingsLayout, PostingsFigureColumnId[]> = {
    split: ['vatRate', 'gross', 'vat', 'net'],
    net_with_invoice: ['net'],
    net: ['net'],
};

export const postingsTableMinWidthPx = (layout: PostingsLayout): number =>
    TEXT_COLUMN_COUNT[layout] * POSTINGS_TEXT_COLUMN_PX +
    FIGURE_COLUMNS[layout].reduce((total, id) => total + POSTINGS_FIGURE_COLUMN_PX[id], 0);

export const POSTINGS_TABLE_MIN_WIDTH_CLASS: Record<PostingsLayout, string> = {
    split: '[&>table]:min-w-[1280px] max-lg:[&>table]:min-w-[1520px]',
    net_with_invoice: 'max-lg:[&>table]:min-w-[1272px]',
    net: 'max-lg:[&>table]:min-w-[1112px]',
};
